<template>
  <div class="column is-full">
    <!-- 커스텀 시도 -->
    <div class="box">
      <admin-box-item title="Featured 지역 시/도 등록하기">
        <div class="btn-group-justify-end">
          <button class="button is-primary" @click="add()">추가하기</button>
        </div>
        <table class="table">
          <thead>
            <tr>
              <th>id</th>
              <th>Featured 지역 시/도</th>
              <th>수정/삭제</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(list,idx) in custom_sido_list" :key="'csido-'+idx">
              <td>{{ list.id }}</td>
              <td>{{ list.name }}</td>
              <td>
                <button class="button half" @click="modifyCustomSido(list.id)">수정</button>
                <button class="button half is-danger" @click="deleteCustomSido(list.id)">삭제</button>
              </td>
            </tr>
          </tbody>
        </table>
      </admin-box-item>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        // 커스터 리스트
        custom_sido_list:[],
        // 커스텀 시도
        custom_sido:{
          name:'',
          sido_set:[]
        },
        customSidoError:false,
        sidoDropBox:false,
        // 일반 시도
        sido_list:[
          /*{
            id: 1,
            name: "강원"
          },
          {
            id: 2,
            name: "경기"
          }*/
        ],
        // 선택된 시도들
        selected_sido:[],
      }
    },
    watch: {
      modalStatus(n) {
        if(n==='close'){
          this.getData();
          this.$emit('getData');
        }
      }
    },
    created(){
      this.getData();
    },
    methods:{
      delTag(index){
        this.custom_sido.sido_set.splice(index, 1);
        this.selected_sido.splice(index, 1);
      },
      add(){
        // 데이터 초기화
        this.custom_sido = {
          name:'',
          sido_set:[]
        };
        this.selected_sido = [];


        let value = {
          custom_sido: this.custom_sido,
          sido_list: this.sido_list,
          selected_sido: this.selected_sido
        }
        this.$store.commit('openModal', {type: 'modal-add-sido', value: value});
      },
      modifyCustomSido(id){
        // 데이터 초기화
        this.custom_sido = {
          id: 0,
          name:'',
          sido_set:[]
        };
        this.selected_sido = [];

        this.$axios.get('admin/address/featured/sido/'+id).then(res=>{
          if(res.status===200){
            this.custom_sido = {
              id: res.data.id,
              name: res.data.name,
              sido_set: res.data.sido_set
            }

            let sido_set = res.data.sido_set
            for(let i=0; i<sido_set.length; i++){
              for(let j=0; j<this.sido_list.length; j++){
                if(sido_set[i] === this.sido_list[j].id){
                  this.selected_sido.push(this.sido_list[j].label);
                }
              }
            }

            let value = {
              custom_sido: this.custom_sido,
              sido_list: this.sido_list,
              selected_sido: this.selected_sido
            }
            this.$store.commit('openModal', {type: 'modal-add-sido', value: value});
          }
        })
      },
      deleteCustomSido(id){
        let value = {
          id: id,
          url: 'address/featured/sido/'
        }
        this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
      },
      getData(){
        // 시도 가져오기
        this.$axios.get('public/address/basic/sido').then(res=>{
          if(res.status===200){
            this.sido_list = res.data;
          }
        });

        // 커스텀 시도 가져오기
        this.$axios.get('admin/address/featured/sido').then(res=>{
          if(res.status===200){
            this.custom_sido_list = res.data;
          }
        });
      }
    }
  }
</script>

<style lang="styl" type="stylus" scoped>
</style>
